import { defineMessages } from 'react-intl';

export default defineMessages({
  uploadImage: {
    id: 'cboard.components.InputImage.uploadImage',
    defaultMessage: 'Upload image'
  }
});
